import * as React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Col, Row } from "react-bootstrap";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import Swal from "sweetalert2";
import SelectButtonFormat from "../../Landing/Components/FormOptions/SelectButtonFormat";
import TelInput from "../../Landing/Components/FormOptions/TelInput";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "ckeditor5-custom-build";
export const ProductsControl = () => {
  const [initialValues, setIntialValues] = useState([]);
  const [Logo, setLogo] = useState("");
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [defaultRows, setDefaultRows] = useState(20);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const defaultValues = {
    title: "",
    price: "",
    sort: 9,
    pic: "",
    status: 1,
    description: "",
    isImageChanged: false,
  };
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const schema = yup.object({
    title: yup
      .string()
      .required("عنوان وارد نشده است.")
      .min(3, "عنوان وارد شده نباید کمتر از 3 کاراکتر باشد."),
    // pic: yup.string().required("عکس انتخاب نشده است."),
    price: yup.string().required("قیمت وارد نشده است."),
  });
  const {
    handleSubmit,
    reset,
    control,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  console.log(errors, "error");
  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "title",
      header: "نام محصول",
    },
    {
      field: "price",
      header: "قیمت",
      body: (data, options) =>
        data.price.toLocaleString("en-US", {
          style: "decimal",
          maximumFractionDigits: 0,
        }),
    },
    {
      field: "status",
      header: "وضعیت نمایش",
      body: (data, options) => (data?.status === 1 ? "فعال" : "غیرفعال"),
    },
    { field: "sort", header: "اولویت" },
    {
      field: "pic",
      header: " عکس",
      body: (data, options) => (
        <div className="">
          <img
            src={`https://api.taab30.com${data?.pic}`}
            className="product-img"
            alt={data?.title}
          />
        </div>
      ),
    },
    {
      field: "title",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];
  const onSubmit = async (data, image) => {
    try {
      let status;
      if (data?.status) {
        status = 1;
      } else {
        status = 0;
      }
      const bodyFormData = new FormData();
      bodyFormData.append("title", data?.title);
      bodyFormData.append("price", data?.price);
      bodyFormData.append("sort", data?.sort);
      if (image) {
        bodyFormData.append("pic", image);
      }
      bodyFormData.append("status", data?.status);
      bodyFormData.append("description", data?.description);
      let cmd = "insertproduct";

      if (selectedUserId) {
        cmd = "updateproduct";
        bodyFormData.append("id", selectedUserId);
      }
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        SweetAlert({
          title: "",
          text: "ویژگی  با موفقیت ذخیره شد.",
          type: "success",
        });
        fetchData("getproduct", {}, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel product route Error: ", error.message);
    }
  };

  const handleUpload = async (w, h, sednFile, data) => {
    if (!watch("isImageChanged")) {
      onSubmit(data);
      return;
    }
    let myImage;
    const image = new Image();
    image.src = sednFile;
    const cWith = w;
    const cHeight = h;
    let percentWidth = 0;
    let percentHeight = 0;

    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const orginalWidht = image.naturalWidth;
      const orginalHeight = image.naturalHeight;
      if (cWith === 0 || cHeight === 0) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      } else {
        percentWidth = cWith / orginalWidht;
        percentHeight = cHeight / orginalHeight;
        const percent =
          percentHeight < percentWidth ? percentHeight : percentWidth;
        canvas.width = image.naturalWidth * percent;
        canvas.height = image.naturalHeight * percent;
      }

      canvas
        .getContext("2d")
        .drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(async (blob) => {
        myImage = new File([blob], "my-new-name.webp", {
          type: blob.type,
        });
      }, "image/webp");
    };
    onSubmit(data, myImage);
  };
  const handleSendImage = (data) => {
    const width = 800;
    const height = 800;
    handleUpload(width, height, Logo, data);
  };

  const getFeatures = () => {
    const bodyFormData = new FormData();
    // bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("getproduct", bodyFormData, handleApiResponse);
  };
  useEffect(() => {
    getFeatures();
  }, []);
  const handleApiResponse = (data) => {
    setPageData(data?.data);
    // setIntialValues(data?.data)
  };
  console.log(initialValues);

  const handleOpeEditItem = (data) => {
    console.log(data);
    setShowEditComponent(true);
    if (data) {
      setIsEditMode(true);
      setSelectedUserId(data?.id);
      console.log(data?.id);
      setIntialValues(data?.pic);
      reset({ ...defaultValues, ...data });
    } else {
      reset(defaultValues);
      setIsEditMode(false);
      setIntialValues([]);
    }
  };

  const onpage = (event) => {
    setLazyState({
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    setDefaultRows(event.rows);
  };
  const toast = useRef(null);
  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "لغو شد",
      detail: "درخواست حذف لغو شد",
      life: 3000,
    });
  };
  const handleOpeDeleteItem = async (id) => {
    console.log(id);
    const bodyFormData = new FormData();
    bodyFormData.append("fid", id);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "delfeatures",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        getFeatures();

        toast.current.show({
          severity: "info",
          summary: "تایید شد",
          detail: "درخواست شما انجام شد",
          life: 3000,
        });
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      show: true,
      title: "حذف محصول",
      text: "آیا می خواهید آیتم را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleOpeDeleteItem(id);
      }
    });
  };
  const stOptions = [
    { label: "فعال", value: 1 },
    { label: "غیرفعال", value: 0 },
  ];
  return (
    <PanelContainer title={"افزودن/ ویرایش محصولات "}>
      <div className="row text-right  p-sm-0  data-table">
        <DataTableTemplate
          lazyState={lazyState}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
          paginator={false}
        />
        <div className="col-6 mt-5 mb-2">
          <Button className="" onClick={() => handleOpeEditItem()}>
            افزودن
          </Button>
        </div>
      </div>
      {showEditComponent && (
        <Form dir="rtl" onSubmit={handleSubmit(handleSendImage)}>
          <div className="panel-heading prime-bg text-white text-center py-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش محصول" : "افزودن محصول جدید"}
            </span>
          </div>
          <div className="panel-body">
            <Row>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="sort"
                  type={"tel"}
                  defaultValue={""}
                  label="اولویت"
                  errors={errors}
                />
              </Col>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="title"
                  type={"text"}
                  label="نام محصول "
                  errors={errors}
                />
              </Col>
            </Row>

            <Row>
              <Col className="col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="price"
                  type={"text"}
                  label="قیمت"
                  errors={errors}
                  maxLength={14}
                />
              </Col>
              {/* <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Flink"
                  type={"text"}
                  label="لینک"
                  errors={errors}
                />
              </Col> */}
              <Col className="col-12 col-lg-6">
                {/* <CheckboxFormat
                  control={control}
                  name="Fstatus"
                  errors={errors}
                  type="checkbox"
                  label="وضعیت نمایش"
                /> */}
                <div className="d-flex flex-direction-column justify-content-start gap-2">
                  <Form.Label className="fw-bold pb-1">وضعیت نمایش</Form.Label>
                  <SelectButtonFormat
                    name={"status"}
                    options={stOptions}
                    control={control}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6">
                <Form.Label className="fw-bold pb-1">
                  {" "}
                  {"   عکس محصول(300px*250px) "}
                </Form.Label>
                <img
                  onClick={() => document.getElementById("fileInput").click()}
                  className="banner-set-image rounded"
                  alt="برای انتخاب عکس محصول کلیک کنید"
                  src={
                    !Logo
                      ? `https://api.taab30.com${initialValues}` || ""
                      : Logo
                  }
                />
                <input
                  type="file"
                  id="fileInput"
                  className="d-none"
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      setLogo(URL.createObjectURL(e.target.files[0]));
                      setValue("isImageChanged", true);
                    }
                  }}
                />
                <div className="d-flex flex-row flex-wrap justify-content-center align-items-center gap-1">
                  <Button
                    onClick={() => document.getElementById("fileInput").click()}
                    className="btn btn-warning"
                    type="button"
                  >
                    انتخاب عکس
                  </Button>
                  {/* <Button type="submit">ذخیره</Button> */}
                </div>
              </Col>
              <Col className="col-12 col-lg-2"></Col>
            </Row>
            <Row>
              <div id="your-editor-container">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <CKEditor
                      {...field}
                      className={"overflow-scroll h-100"}
                      editor={ClassicEditor}
                      data={field.value}
                      // onReady={editor => {
                      //     console.log('Editor is ready to use!', editor);
                      // }}

                      onChange={(event, editor) => {
                        const data = editor.getData();
                        field.onChange(data);
                      }}
                    />
                  )}
                  name={"description"}
                />
              </div>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6">
                <Button type="submit">ذخیره</Button>
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </PanelContainer>
  );
};
